import { createApi } from '@reduxjs/toolkit/query/react'
import baseQueryWithReauth from './baseQuery'
import { FetchDatasetResp } from '../types/api/responses'
import { DATASETS_URL } from '../constants'
import { apiTags } from './apiTags'
import { UpdateDatasetReq } from '../types/api/api-dataset'

export const datasetApi = createApi({
  reducerPath: 'datasetApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: [apiTags.Dataset, apiTags.DatasetList],
  endpoints: (builder) => ({
    fetchDataset: builder.query<FetchDatasetResp, string>({
      query: (datasetId) => `${DATASETS_URL}/${datasetId}`,
      providesTags: (result, error, datasetId) => [
        { type: apiTags.Dataset, datasetId },
        { type: apiTags.DatasetList, id: 'LIST' },
      ],
    }),

    updateDataset: builder.mutation<FetchDatasetResp, UpdateDatasetReq>({
      query: ({ Id, split }) => ({
        url: `${DATASETS_URL}/${Id}`,
        method: 'PATCH',
        body: { split },
      }),
      invalidatesTags: (result, error, { Id }) => [
        { type: apiTags.Dataset, id: Id },
        { type: apiTags.DatasetList, id: 'LIST' },
      ],
    }),
  }),
})

export const { useFetchDatasetQuery, useUpdateDatasetMutation } = datasetApi
